import React from 'react';
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import store from './store'
import './styles/main.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BrowserRouter><Provider store={store}><App /></Provider></BrowserRouter>);

// serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();
